"use client";
import { useEffect, useState } from "react";

import LoginStep1 from "/forms/LoginStep1";
import LoginStep2 from "/forms/LoginStep2";
import { Block, Section } from "/components/Layout";
import Seo from "/utils/seo";
import Footer from "/components/Footer";

function Page() {
  // Get temp jwt token (with mobile number) and requestId from step 1
  // This is passed together with the form in step 2
  const [tokenSent, setTokenSent] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    //Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo page={{ title: "Logg inn" }} noindex={true} />
      <article>
        <Section center limitedWidthSmall outer="firstSection">
          <Block bottom={7} mobileTop={4}>
            <h1>Logg inn</h1>
          </Block>
          <Block>
            <p className="body-quote">
              Se relevant informasjon knyttet til deg og din sykkel, eller for å bestille time for
              hjelp og service på vårt verksted.{" "}
            </p>
          </Block>

          <Block top={10} mobileTop={6}>
            {!tokenSent ? (
              <>
                {/* Step 1 - Enter mobile number */}
                <LoginStep1 setPhoneNumber={setPhoneNumber} setTokenSent={setTokenSent} />
              </>
            ) : (
              <>
                {/* Step 2 - Enter pin verification */}
                <LoginStep2 phoneNumber={phoneNumber} />
              </>
            )}
          </Block>
        </Section>

        <Footer />
      </article>
    </>
  );
}

export default Page;
